/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_DenyInputs */

const en_agent_authorization_deny = /** @type {(inputs: Agent_Authorization_DenyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject request`)
};

const zh_agent_authorization_deny = /** @type {(inputs: Agent_Authorization_DenyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拒绝请求`)
};

/**
* | output |
* | --- |
* | "Reject request" |
*
* @param {Agent_Authorization_DenyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_deny = /** @type {((inputs?: Agent_Authorization_DenyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_DenyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_deny(inputs)
	return zh_agent_authorization_deny(inputs)
});
export { agent_authorization_deny as "agent.authorization.deny" }